import ImageButton from "@/components/button/image-button";
import Text from "./../components/text/text";
import { useNavigate } from "react-router-dom";
import { useNavigationStore } from "@/store/navigationStore";
import HomeChat from "@/components/home/home-chat";
import { useCrimeSceneStore } from "@/store/crimeSceneStore";
import { CrimeSceneSteps } from "@/types/crime";
import { getAvatarImageByType } from "@/utils/simulation";
import Image from "./../components/image";
import { CHAT_TYPE } from "@/types/navigation-mode";
import { useEffect, useState } from "react";
import LottieLoading from "@/components/lottie/lottie-loading";
import { useTranslation } from "react-i18next";
import { ALL_SCENES_DATA } from "@/const/crimeSceneConst";

export default function SimulationChatPage() {
  let navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  const SimulationChatHeader = () => {
    return (
      <div className="flex p-[20px] w-full justify-center">
        <div className="flex justify-between items-center w-full md:w-[520px]">
          <Text text="Simulation" className="text-500" size={18} />
          <ImageButton
            onClick={() => {
              navigate("/");
            }}
            className="button-glass"
            src="/assets/icon_close.png"
            alt="close button"
            size={22}
          />
        </div>
      </div>
    );
  };

  const SimulationChatContent = () => {
    const userQuery = useNavigationStore((state) => state.userQuery);
    const crimeSceneSteps = useCrimeSceneStore(
      (state) => state.crimeSceneSteps
    );
    const { t } = useTranslation();
    const crimeSceneContent = () => {
      return crimeSceneSteps.map((step: CrimeSceneSteps, i: number) => {
        const sceneDesc = ALL_SCENES_DATA.find(scene => scene.sceneIndex == step.scene);
        return <div
          key={step.title}
          className="w-full md:w-[520px] p-[20px] border-b border-white/70 transition relative"
        >
          {/* Row 1: image and title/arrow flex row */}
          <div className="flex items-center gap-4">
            {/* <Image
              width={96}
              height={72}
              src={`/${step.image}`}
              alt={step.title}
              className="rounded-lg object-cover flex-shrink-0"
            /> */}
            <div className="flex-1 flex justify-between items-center">
              <div className="text-lg text-500">{t(step.title)}</div>
            </div>
          </div>
          {/* Metadata row */}
          <div className="flex flex-col gap-1 text-sm mt-3">
            <div className="flex items-center gap-2">
              <Image
                width={24}
                height={24}
                src="/assets/icon_calendar.svg"
                alt="Calendar icon"
              />
              {step.date}
            </div>
            {/* <div className="flex items-center gap-2 mt-3">
              <Image
                width={24}
                height={24}
                src="/assets/icon_clock.svg"
                alt="Clock icon"
              />
              {step.time}
            </div> */}
            <div className="flex items-center gap-2 mt-3">
              <Image
                width={24}
                height={24}
                src="/assets/icon_pin.svg"
                alt="Pin icon"
              />
              {step.location}
            </div>
            <div className="flex items-center gap-2 mt-3">
              {step.avatars.map((avatarName, avatarMapIndex) => (
                <div
                  key={`avatar_container${i}_${avatarName}`}
                  className="w-6 h-6 overflow-hidden rounded-full bg-white"
                >
                  <Image
                    src={`/assets/${getAvatarImageByType(avatarName)}`}
                    alt={`${avatarName} icon`}
                    className="object-cover -mt-0"
                  />
                </div>
              ))}
            </div>
          </div>
          {/* Row 2: description below */}

          <div className="mt-2 text-base leading-snug mt-3">
            {sceneDesc?.messages.map((sceneMessage, index) => <div key={index} className="whitespace-pre-line mt-4">
              {t(sceneMessage)}
            </div>)}
          </div>


          {/*<div className="mt-2 text-base leading-snug mt-3">
            {typeof step.description === "string" ? (
              <span>{step.description}</span>
            ) : (
              step.description
            )}
          </div>*/}
        </div>
      });

    };

    return (
      <div className="flex flex-col">
        <div className="flex justify-end mb-[20px]">
          <Text
            text={userQuery}
            translate={false}
            className="rounded-lg p-[12px] bg-simulation-chat-user"
          />
        </div>

        {crimeSceneContent()}

        <div className="p-[20px] mb-[20px]">
          <div className="mb-[12px]">
            Here is a simulation based on your requirements:
          </div>
          <div
            className="relative cursor-pointer w-[240px]"
            onClick={() => navigate("/simulation")}
          >
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <Image
                src={`/assets/icon_play.png`}
                className="rounded-lg"
                width={48}
                height={48}
              />
            </div>
            <Image
              src={`/${crimeSceneSteps[0].image}`}
              alt={crimeSceneSteps[0].title}
              className="rounded-lg w-[240px] h-[160px] object-cover flex-shrink-0"
              width={240}
              height={160}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className="flex landing min-h-screen"
        style={{ backgroundImage: 'url("/assets/bg_landing.jpg")' }}
      >
        {loading ? (
          <div className="flex flex-1 p-4 items-center justify-center">
            <LottieLoading />
          </div>
        ) : (
          <div className="flex flex-col simulation-chat-landing w-full md:items-center">
            <SimulationChatHeader />
            <div className="flex flex-1 md:flex-row">
              <SimulationChatContent />
            </div>

            <HomeChat withTabs={false} chatType={CHAT_TYPE.SIMULATION} />
          </div>
        )}
      </div>
    </>
  );
}
